import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { GMapComponent } from './gmap.component';
// import { MapComponent } from './map.component';

@NgModule({
  declarations: [
    GMapComponent,
    // MapComponent
  ],
  imports: [
    CommonModule,
    GoogleMapsModule
  ],
  exports: [
    GMapComponent,
    // MapComponent
  ]
})
export class MapModule { }